/**
 * @generated SignedSource<<a96dc04c9fd9e58c20e5194f44fb5123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateAccountInput = {
  accountType: string;
  clientMutationId?: string | null | undefined;
  discountCategory?: string | null | undefined;
  discountPercentage?: number | null | undefined;
  email?: string | null | undefined;
  firstName: string;
  lastName?: string | null | undefined;
  paidBySchool?: boolean | null | undefined;
  parentOrChildren?: ReadonlyArray<ParentOrChildrenAccountInput | null | undefined> | null | undefined;
  password?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  profileId?: string | null | undefined;
  schoolId?: string | null | undefined;
  schoolYear?: number | null | undefined;
};
export type ParentOrChildrenAccountInput = {
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  password?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  profileId?: string | null | undefined;
  schoolId?: string | null | undefined;
  schoolYear?: number | null | undefined;
};
export type CreateAccountMutation$variables = {
  input: CreateAccountInput;
  parentConnections: ReadonlyArray<string>;
  pupilConnections: ReadonlyArray<string>;
  relevantConnections: ReadonlyArray<string>;
};
export type CreateAccountMutation$data = {
  readonly createAccount: {
    readonly children: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AccountListFragment_ProfileNode">;
    } | null | undefined> | null | undefined;
    readonly errors: any | null | undefined;
    readonly parent: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AccountListFragment_ProfileNode">;
    } | null | undefined;
    readonly profile: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AccountListFragment_ProfileNode">;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type CreateAccountMutation = {
  response: CreateAccountMutation$data;
  variables: CreateAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentConnections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pupilConnections"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantConnections"
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "AccountListFragment_ProfileNode"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v12 = [
  (v7/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInvalidPhoneNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "schoolYear",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "discountCategory",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "discountPercentage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dbsNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dbsExpirationDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SchoolNode",
    "kind": "LinkedField",
    "name": "school",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DjangoUserNode",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSuperuser",
        "storageKey": null
      },
      (v7/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProfileNode",
    "kind": "LinkedField",
    "name": "primaryParent",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "DjangoUserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "kind": "Literal",
  "name": "edgeTypeName",
  "value": "ProfileNodeEdge"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateAccountPayload",
        "kind": "LinkedField",
        "name": "createAccount",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateAccountPayload",
        "kind": "LinkedField",
        "name": "createAccount",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "profile",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "relevantConnections"
              },
              (v13/*: any*/)
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "parent",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "parentConnections"
              },
              (v13/*: any*/)
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "children",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "pupilConnections"
              },
              (v13/*: any*/)
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac8f290521b7f7a386e34aee12b9b4fa",
    "id": null,
    "metadata": {},
    "name": "CreateAccountMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAccountMutation(\n  $input: CreateAccountInput!\n) {\n  createAccount(input: $input) {\n    success\n    errors\n    profile {\n      id\n      ...AccountListFragment_ProfileNode\n    }\n    parent {\n      id\n      ...AccountListFragment_ProfileNode\n    }\n    children {\n      id\n      ...AccountListFragment_ProfileNode\n    }\n  }\n}\n\nfragment AccountListFragment_ProfileNode on ProfileNode {\n  id\n  accountNumber\n  accountType\n  phoneNumber\n  hasInvalidPhoneNumber\n  schoolYear\n  status\n  discountCategory\n  discountPercentage\n  dbsNumber\n  dbsExpirationDate\n  school {\n    id\n    name\n  }\n  user {\n    firstName\n    lastName\n    email\n    isSuperuser\n    id\n  }\n  primaryParent {\n    id\n    accountNumber\n    user {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4df229b2893e3a485e15048d278a6fc6";

export default node;
